import { NgModule } from "@angular/core";
import { AgGridModule } from "ag-grid-angular";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { LaggtillSystemaktivitetComponent } from "~app/features/administration/systemaktivitet/laggtill-systemaktivitet/laggtill-systemaktivitet.component";
import { SystemaktivitetContainerComponent } from "~app/features/administration/systemaktivitet/systemaktivitet-container/systemaktivitet-container.component";
import { SystemaktivitetNotisComponent } from "~app/features/administration/systemaktivitet/systemaktivitet-notis/systemaktivitet-notis.component";
import { SystemaktivitetComponent } from "~app/features/administration/systemaktivitet/systemaktivitet.component";
import { SystemaktivitetService } from "~app/features/administration/systemaktivitet/systemaktivitet.service";

@NgModule({
    imports: [
        RaskCommonModule,
        AgGridModule,
        SystemaktivitetComponent,
        SystemaktivitetContainerComponent,
        LaggtillSystemaktivitetComponent,
        SystemaktivitetNotisComponent
    ],
    exports: [SystemaktivitetNotisComponent],
    providers: [SystemaktivitetService]
})
export class SystemaktivitetModule { }
